import {ChangeDetectionStrategy, Component, computed, inject, RESPONSE_INIT} from '@angular/core';
import {
  ApartmentDetailPageContentComponent
} from "../../../components/apartment-detail-page-content/apartment-detail-page-content.component";
import {AsyncPipe} from "@angular/common";
import {map, switchMap, tap} from "rxjs";
import {validatedNotNull} from "../../../utils";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {ApartmentService} from "../../../services/apartment.service";
import {initialSignupRoute, initialSignupRouteIncludingInfo} from "../../signup/specific-signup.routes";
import {
  ApartmentDetailInfoItemComponent
} from "../../apartments-tab/apartment-detail-page/apartment-detail-info-item/apartment-detail-info-item.component";
import {RegularEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/regular-eligible-units.component";
import {SeniorEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/senior-eligible-units.component";
import {toSignal} from "@angular/core/rxjs-interop";
import {LotteriesAndFooterComponent} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";
import {ButtonDirective, ButtonLabel} from "primeng/button";
import {Divider} from "primeng/divider";
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {getApartmentCacheDuration, injectSsrRequestContext, ONE_MINUTE} from "../../../ssr-cache-utils";

@Component({
  selector: 'homey-public-apartment-detail-page',
  imports: [
    ApartmentDetailPageContentComponent,
    AsyncPipe,
    ApartmentDetailInfoItemComponent,
    RegularEligibleUnitsComponent,
    SeniorEligibleUnitsComponent,
    RouterLink,
    LotteriesAndFooterComponent,
    ButtonDirective,
    ButtonLabel,
    Divider,
    PageTitleComponent,
  ],
  templateUrl: './public-apartment-detail-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicApartmentDetailPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly apartmentService = inject(ApartmentService);
  private readonly responseInit = inject(RESPONSE_INIT, { optional: true });
  private readonly requestContext = injectSsrRequestContext();

  public readonly apartment$ =
    this.route.paramMap.pipe(
      map(params => validatedNotNull(params.get('lotteryId'))),
      switchMap(apartmentId => this.apartmentService.getApartmentOrUndefined(apartmentId)),
      tap(apartment => {
        if (!apartment) {
          if (this.responseInit) {
            this.responseInit.status = 404;
          }
          if (this.requestContext) {
            this.requestContext.cacheDuration = ONE_MINUTE;
          }
        } else {
          if (this.requestContext) {
            this.requestContext.cacheDuration = getApartmentCacheDuration(apartment);
          }
        }
      }),
    );

  private readonly currentApp = toSignal(this.apartment$);
  protected readonly otherApartments =
    computed(() => (this.apartmentService.openLotteries() ?? []).filter(
      lottery => lottery.borough === this.currentApp()?.borough && lottery.id !== this.currentApp()?.id
    ))

  protected readonly initialSignupRoute = initialSignupRoute;
  protected readonly initialSignupRouteIncludingInfo = initialSignupRouteIncludingInfo;
}
